import { status, StatusType } from '../typeStatus'

export const GET_USERS = 'GET_USERS'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_ERROR = 'GET_USERS_ERROR'
export const DELETE_USER = 'DELETE_USER'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR'
export const CREATE_USER = 'CREATE_USER'
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR'
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const CREATE_USER_RESET = 'CREATE_USER_RESET'
export const GET_USER_DATA = 'GET_USER_DATA'
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS'
export const GET_USER_DATA_ERROR = 'GET_USER_DATA_ERROR'
export const UPDATE_SELECTED = 'UPDATE_SELECTED'
export const DELETE_USER_RESET = 'DELETE_USER_RESET'
export const DELETE_USER_SOME_ERROR = 'DELETE_USER_SOME_ERROR'
export const USERS_NOT_DELETED = 'USERS_NOT_DELETED'

export interface Pagination {
  currentPage: number,
  totalPages: number,
  elementsPerPage: number,
  totalElements: number
}

export interface GetListUsersType {
  users: GetUsersType[] | null,
  pagination: Pagination | null
}

export interface GetUsersType {
  id: number
  usuario: string
  denominacion: string
  limitePublicaciones: number
  tipoUsuario: string
  avisosActivos: number
}

export interface GetUserDataType {
  apellido: string
  email: string
  limitePublicaciones: 0
  nombre: string
  puesto: string
  tipoUsuario: string
  usuario: string
}
export interface PostUsersType {
  status: StatusType
  invalidUsername: boolean
}
export interface ListUsersType {
  [index: number]: number
}

export interface UpdateListUsersSeleted {
  type: typeof UPDATE_SELECTED
  payload: ListUsersType | null
}

export interface CreateUser {
  type: typeof CREATE_USER
  payload: boolean | null
}

export interface CreateUserSuccess {
  type: typeof CREATE_USER_SUCCESS
  payload: null
}
export interface CreateUserError {
  type: typeof CREATE_USER_ERROR
  payload: boolean
}
export interface CreateUserReset {
  type: typeof CREATE_USER_RESET
  payload: null
}
export interface DeleteUser {
  type: typeof DELETE_USER
  payload: boolean
}

export interface DeleteUserReset {
  type: typeof DELETE_USER_RESET
  payload: null
}
export interface DeleteUserSuccess {
  type: typeof DELETE_USER_SUCCESS
  payload: null
}
export interface DeleteUserError {
  type: typeof DELETE_USER_ERROR
  payload: null
}
export interface DeleteUserSomeError {
  type: typeof DELETE_USER_SOME_ERROR
  payload: null
}

export interface UsersNotDeleted {
  type: typeof USERS_NOT_DELETED
  payload: number[] | null
}

export interface GetUsers {
  type: typeof GET_USERS
  payload: GetUsersType | null
}

export interface GetUsersSuccess {
  type: typeof GET_USERS_SUCCESS
  payload: GetListUsersType
}
export interface GetUsersError {
  type: typeof GET_USERS_ERROR
  payload: null
}

export interface GetUserData {
  type: typeof GET_USER_DATA
  payload: null
}

export interface GetUserDataSuccess {
  type: typeof GET_USER_DATA_SUCCESS
  payload: GetUserDataType
}

export interface GetUserDataError {
  type: typeof GET_USER_DATA_ERROR
  payload: null
}

export interface UsersState {
  status: StatusType
  users: GetUsersType[] | null
  listUsers: ListUsersType | null
  pagination: Pagination | null
  usersNotDeleted: number[] | null
  selectedUserData: { data: GetUserDataType | null; fetchStatus: StatusType; isEdit: boolean | null }
  createUser: PostUsersType
  deleteUser: {
    status: StatusType
    isMultiple: boolean | null
  }
}

export const initialState: UsersState = {
  status: status.initial,
  users: [],
  listUsers: [],
  pagination: null,
  usersNotDeleted: [],
  selectedUserData: { fetchStatus: status.initial, data: null, isEdit: null },
  createUser: { status: status.initial, invalidUsername: false },
  deleteUser: {
    status: status.initial,
    isMultiple: null,
  },
}

export type UsersActions =
  | GetUsers
  | GetUsersError
  | GetUsersSuccess
  | DeleteUser
  | DeleteUserError
  | DeleteUserSuccess
  | CreateUser
  | CreateUserError
  | CreateUserSuccess
  | CreateUserReset
  | DeleteUserReset
  | GetUserData
  | GetUserDataSuccess
  | GetUserDataError
  | DeleteUserSomeError
  | UpdateListUsersSeleted
  | UsersNotDeleted
